<div style="display:flex; flex-wrap:wrap; align-items:center;">
    @for (att of attachments; track att.id) {
        <div class="chip" [matTooltip]="att.notes">
            <p>{{att.name}}</p>
            <mat-icon style="font-size:14px; height:14px; width:14px" color="warn"
                matTooltip="Delete" (click)="removeAttachment(att)">delete</mat-icon>
        </div>
    }
    <button mat-icon-button color="primary" (click)="addAttachment()" matTooltip="Add attachment">
        <mat-icon>add_circle</mat-icon>
    </button>
    @if (sizeExceeded) {
        <span style="color:red; font-size:small; margin-left:4px;">{{totalSizeMb}} MB — exceeds 9.5 MB limit</span>
    }
</div>
